import { useContext, useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Invoices/NewInvoice.css";
import { billingMicroserviceUrl } from "../../../../microservices/billing_microservice";
import "react-datepicker/dist/react-datepicker.css";
import { AppContext } from "../../../AppProvider";
import DatePicker from "react-datepicker";
import ToogleButton from "../../../controls/ToogleButton";
import { InvoiceContext } from "./InvoiceProvider";
import { useSearchParams } from "react-router-dom";
const NewInvoice = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        setReloadInvoices,
        showNewInvoiceWindow,setShowNewInvoiceWindow
    } = useContext(InvoiceContext);
    const [searchParams,setSearchParams] = useSearchParams();
    const sub_id = searchParams.get('sub_id');
    const [creatingInvoiceStatus,setCreatingInvoiceStatus] = useState('');
    const [selectedNewInvoiceTab,setSelectedNewInvoiceTab] = useState('default');
    const [showDurationTypeBrowser,setShowDurationTypeBrowser] = useState(false);
    const [showCustomerAccountBrowser,setShowCustomerAccountBrowser] = useState(false);
    const [customerAccountFilterString,setCustomerAccountFilterString] = useState('');
    const [durationTypeFilterString,setDurationTypeFilterString] = useState('');
    const [selectedAvailableSubscriptionsIds,setSelectedAvailableSubscriptionsIds] = useState([]);
    const [availableSubscriptions,setAvailableSubscriptions] = useState(null);
    const [loadingAvailableSubscriptions,setLoadingAvailableSubscriptions] = useState(false);
    const [preLoadedDeviceSubscription,setPreLoadedDeviceSubscription] = useState(null);

    const [customerName,setCustomerName] = useState('');
    const [customerKRAPIN,setCustomerKRAPIN] = useState('');
    const [selectedCustomerAccount,setSelectedCustomerAccount] = useState(null);
    const [invoiceStartDate,setInvoiceStartDate] = useState(null);
    const [selectedDurationType,setSelectedDurationType] = useState(null);
    const [autogenerateInvoice,setAutogenerateInvoice] = useState(true);
    const [notesEntries,setNotesEntries] = useState([]);
    const [subscriptionsEntries,setSubscriptionsEntries] = useState([]);

    const [billingAccounts,setBillingAccounts] = useState(null);
    const durationTypes = [
        {value: 'DAILY',display:'Daily'},
        {value: 'WEEKLY',display: 'Weekly'},
        {value: 'MONTHLY',display: 'Monthly'},
        {value: 'QUARTERLY',display: 'Quarterly'},
        {value: 'SEMI_ANNUAL',display: 'Semi Annually'},
        {value: 'ANNUAL', display: 'Annually'},
        {value: 'PERPETUAL',display: 'Perpetual'}
    ];

    const fetchBillingAccounts = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/accounts`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok) setBillingAccounts(await response.json());
            else throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when processing the request: ${error}`)
        }
    };
    const fetchAvailableSubscriptions = async() =>{
        try{
            if(!selectedDurationType?.value) return;
            setLoadingAvailableSubscriptions(true);
            const url = `${billingMicroserviceUrl}/tenants/subscriptions/postpaid?invoiced=false&&durationType=${selectedDurationType?.value}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok) setAvailableSubscriptions(await response.json());
        }
        catch(error){
            console.error('An error occurred when fetching available subscriptions:',error);
        }
        setLoadingAvailableSubscriptions(false);
    };
    const fetchPreloadedDeviceSubscription = async(id) =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/subscriptions/${id}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok) setPreLoadedDeviceSubscription(await response.json());
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`status code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when retrieving device subscription',error);
        }
    }
    const createInvoice = async() =>{
        try{
            setCreatingInvoiceStatus('creating');
            const createInvoicePayload = {
                customerName:customerName,
                customerKRAPIN:customerKRAPIN,
                customerAccountId:selectedCustomerAccount?.accountId,
                startDateTime:invoiceStartDate? invoiceStartDate.toISOString().slice(0,-1):null,
                durationType:selectedDurationType?.value,
                autogenerate:autogenerateInvoice,
                notes:notesEntries && notesEntries?.map((noteEntry) => (noteEntry?.value)),
                devicesSubscriptionsIds:subscriptionsEntries && subscriptionsEntries?.reduce((acc,subscriptionEntry,index) => {acc[index] =subscriptionEntry?.value?.subscriptionId;return acc;},{})
            };
            const url = `${billingMicroserviceUrl}/tenants/invoices`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Authorization':`Bearer ${user?.access_token}`,
                    'Content-Type':'application/json'
                },
                body:JSON.stringify(createInvoicePayload)
            });
            if(response.ok){
                setCreatingInvoiceStatus('created');
                setReloadInvoices(true);
                return;
            }
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(`status code: ${response?.status}`);
        }
        catch(error){
            console.error('An error occurred when creating an invoice',error);
        }
        setCreatingInvoiceStatus('error');
    };
    const deleteSubIdParam = () =>{
        const newParams = new URLSearchParams(searchParams);
        newParams.delete('sub_id');
        setSearchParams(newParams);
    };
    const formValidToolTip = () =>{
        if(customerName === '') return 'Enter the customer name to proceed';
        else if(selectedCustomerAccount === null) return 'Select the customer acccount to bill to proceed';
        else if(invoiceStartDate === null) return 'Select the invoice start date to proceed';
        else if(selectedDurationType === null) return 'Select the invoice duration type to proceed';
        else if(!subscriptionsEntries || subscriptionsEntries.length === 0) return 'Add at least one subscription entry to proceed';
        else if(notesEntries && notesEntries?.some((entry) => (entry?.value === null || entry?.value === ''))) return 'Each note entry must have a value';
        else if(subscriptionsEntries && subscriptionsEntries?.some((entry) => (entry.value === null))) return 'Each subscription entry must have a valid post paid device subscription';
        return '';
    }
    const disposeWindow = () =>{
        setSelectedNewInvoiceTab('default');
        setCreatingInvoiceStatus('');
        setShowNewInvoiceWindow(false);
        setCustomerName('');
        setCustomerKRAPIN('');
        setSelectedCustomerAccount(null);
        setInvoiceStartDate(null);
        setSelectedDurationType(null);
        setAutogenerateInvoice(true);
        setNotesEntries([]);
        setSubscriptionsEntries([]);
    };
    useEffect(() =>{
        if(showNewInvoiceWindow) fetchBillingAccounts();
    },[showNewInvoiceWindow]);
    useEffect(() =>{
        if(!sub_id) return;
        if(preLoadedDeviceSubscription){
            setSelectedDurationType(durationTypes.find(type => type.value === preLoadedDeviceSubscription?.planDuration));
            deleteSubIdParam();
            return;
        }
        fetchPreloadedDeviceSubscription(sub_id);
    },[sub_id,preLoadedDeviceSubscription]);
    useEffect(() =>{
        if(!Array.isArray(availableSubscriptions) || !Array.isArray(subscriptionsEntries) || !preLoadedDeviceSubscription) return;
        if(subscriptionsEntries.length === 0 && availableSubscriptions.some(sub => sub?.subscriptionId === preLoadedDeviceSubscription?.subscriptionId)){
            setSubscriptionsEntries([{
                id:Date.now(),
                filterString:'',
                value:availableSubscriptions.find(sub => sub?.subscriptionId === preLoadedDeviceSubscription?.subscriptionId),
                showBrowser:false
            }]);
        }
    },[availableSubscriptions,preLoadedDeviceSubscription]);
    useEffect(() =>{
        const handleEsc = (e) =>{
            if(e.key === "Escape" && creatingInvoiceStatus !== 'creating') disposeWindow();
        };
        document.addEventListener("keydown",handleEsc);
        return () =>{
            document.removeEventListener("keydown",handleEsc);
        };
    },[showNewInvoiceWindow,creatingInvoiceStatus]);
    useEffect(() =>{
        if(selectedNewInvoiceTab !== 'subscriptions') return;
        fetchAvailableSubscriptions();
    },[selectedNewInvoiceTab]);
    useEffect(() =>{
        setSelectedAvailableSubscriptionsIds(subscriptionsEntries && subscriptionsEntries?.map((subscriptionEntry) => (subscriptionEntry?.value?.subscriptionId)) || []);
    },[subscriptionsEntries]);
    if(!showNewInvoiceWindow) return null;
    return(
        <div className="tenant-administrator-new-invoice-parent-container">
            {creatingInvoiceStatus === ''?
                (
                    <div className="tenant-administrator-new-invoice-container">
                        <div className="tenant-administrator-new-invoice-header">
                            <h1>Add an Invoice</h1>
                            <p onClick={() => disposeWindow()}>&#10006;</p>
                        </div>
                        <div className="tenant-administrator-new-invoice-body">
                            <div className="tenant-administrator-new-invoice-body-navigation-bar">
                                <button className={selectedNewInvoiceTab === 'primary-details' || selectedNewInvoiceTab === 'default'? 'active':''}
                                    onClick={() => setSelectedNewInvoiceTab('primary-details')}>Primary details</button>
                                <button className={selectedNewInvoiceTab === 'subscriptions'? 'active':''}
                                    onClick={() => setSelectedNewInvoiceTab('subscriptions')}>Subscriptions</button>
                            </div>
                            <div className={`tenant-administrator-new-invoice-primary-details-container ${selectedNewInvoiceTab === 'default'? 'default':selectedNewInvoiceTab === 'primary-details'? 'active':'inactive'}`}>
                                <div className="tenant-administrator-new-invoice-entry-container">
                                    <p>Customer name<span>*</span></p>
                                    <input
                                        placeholder="Enter customer name"
                                        value={customerName}
                                        onChange={(e) => setCustomerName(e.target.value)}
                                    />
                                </div>
                                <div className="tenant-administrator-new-invoice-entry-container">
                                    <p>Customer KRA PIN</p>
                                    <input
                                        placeholder="Enter customer KRA PIN"
                                        value={customerKRAPIN}
                                        onChange={(e) => setCustomerKRAPIN(e.target.value)}
                                    />
                                </div>
                                <div className="tenant-administrator-new-invoice-entry-container">
                                    <p>Customer Account<span>*</span></p>
                                    {selectedCustomerAccount? 
                                        (
                                            <div className="tenant-administrator-new-invoice-selected-customer-account-container">
                                                <p>{selectedCustomerAccount?.accountNumber}</p>
                                                <p>
                                                    {selectedCustomerAccount?.userEmailAddress}
                                                    <span onClick={() => setSelectedCustomerAccount(null)}>&#10006;</span>
                                                </p>
                                            </div>
                                        ):
                                        (
                                            <input
                                                placeholder="Enter customer account number or email address"
                                                value={customerAccountFilterString}
                                                onChange={(e) =>{
                                                    setCustomerAccountFilterString(e.target.value)
                                                }}
                                                onFocus={() => setShowCustomerAccountBrowser(true)}
                                                onBlur={() =>{
                                                    setTimeout(() =>{setShowCustomerAccountBrowser(false)},100)
                                                }}
                                            />
                                        )
                                    }
                                    <div className={`tenant-administrator-new-invoice-customer-account-browser ${showCustomerAccountBrowser? 'active':''}`}>
                                        {billingAccounts && billingAccounts.filter((billingAccount) =>(
                                            billingAccount?.accountNumber?.includes(customerAccountFilterString) || billingAccount?.userEmailAddress?.includes(customerAccountFilterString)
                                        )).map((billingAccount) =>(
                                            <div key={billingAccount?.accountId} onClick={() =>{
                                                setCustomerAccountFilterString('');
                                                setSelectedCustomerAccount(billingAccount);
                                            }}>
                                                <p>{billingAccount?.accountNumber}</p>
                                                <p>{billingAccount?.userEmailAddress}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="tenant-administrator-new-invoice-entry-container">
                                    <p>Start Date<span>*</span></p>
                                    <DatePicker
                                        placeholderText="Select start date and time"
                                        selected={invoiceStartDate}
                                        onChange={(e) => setInvoiceStartDate(e)}
                                        minDate={Date.now()}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={15}
                                        dateFormat={"dd/MM/yyyy HH:mm"}
                                        popperPlacement="bottom-end"
                                    />
                                </div>
                                <div className="tenant-administrator-new-invoice-entry-container">
                                    <p>Duration Type<span>*</span></p>
                                    {selectedDurationType? 
                                    (
                                        <div className="tenant-administrator-new-invoice-selected-duration-type-container">
                                            <p>{selectedDurationType?.display}</p>
                                            <p className="cancel-p" onClick={() => setSelectedDurationType(null)}>&#10006;</p>
                                        </div>
                                    ):(
                                        <input
                                            placeholder="Enter duration type"
                                            value={durationTypeFilterString}
                                            onChange={(e) =>{
                                                setDurationTypeFilterString(e.target.value);
                                            }}
                                            onFocus={() => setShowDurationTypeBrowser(true)}
                                            onBlur={() => {
                                                setTimeout(() =>{setShowDurationTypeBrowser(false)},150);
                                            }}
                                        />
                                    )}
                                    <div className={`tenant-administrator-new-invoice-duration-type-browser ${showDurationTypeBrowser? 'active':''}`}>
                                        {durationTypes.filter((durationType) => (
                                            durationType?.display?.toLowerCase()?.includes(durationTypeFilterString.toLowerCase())
                                        )).map((durationType) =>(
                                            <div key={durationType?.value}
                                                onClick={() =>{
                                                    setDurationTypeFilterString('');
                                                    setSelectedDurationType(durationType);
                                                }}>
                                                {durationType?.display}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="tenant-administrator-new-invoice-autogenerate-container">
                                    <ToogleButton
                                        size="40px"
                                        marginRight="10px"
                                        isToogled={autogenerateInvoice}
                                        onChange={() => setAutogenerateInvoice(!autogenerateInvoice)}
                                    />
                                    <p>Auto generate {selectedDurationType?.display?.toLowerCase()}</p>
                                </div>
                                <div className="tenant-administrator-new-invoice-notes-container">
                                    <div className="tenant-administrator-new-invoice-notes-header">
                                        <h3>Notes</h3>
                                        <p title="Add a note" onClick={() => setNotesEntries([...notesEntries,{id: Date.now(), value: ""}])}>+</p>
                                    </div>
                                    <div className="tenant-administrator-new-invoice-notes-body">
                                        {notesEntries.map((noteEntry,index) =>(
                                            <div className={noteEntry?.value.length === 0? 'empty':''} key={noteEntry?.id}>
                                                <p>{index + 1}.</p>
                                                <input
                                                    value={noteEntry?.value}
                                                    onChange={(e) => setNotesEntries(prev => prev.map(
                                                        (entry) => entry.id === noteEntry?.id? {...entry,value:e.target.value}:entry
                                                    ))}
                                                />
                                                <img
                                                    title="Delete entry"
                                                    onClick={() =>{
                                                        setNotesEntries(prev => (prev.filter(entry => entry?.id !== noteEntry?.id)))
                                                    }}
                                                    src={`${process.env.PUBLIC_URL}/images/delete-icon.png`}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className={`tenant-administrator-new-invoice-subscriptions-container ${selectedNewInvoiceTab === 'default'? 'default':selectedNewInvoiceTab === 'subscriptions'? 'active':'inactive'}`}>
                                <div className="tenant-administrator-new-invoice-subscriptions-header">
                                    <h3>Subscriptions</h3>
                                    <p
                                        title="Add a subscription"
                                        style={{display:loadingAvailableSubscriptions || !selectedDurationType? 'none':'block'}}
                                        onClick={() => setSubscriptionsEntries([...subscriptionsEntries,{id:Date.now(),filterString:'',value:null,showBrowser:false}])}>+
                                    </p>
                                </div>
                                <div className="tenant-administrator-new-invoice-subscription-body">
                                    {!selectedDurationType?
                                        (
                                            <div className="tenant-administrator-new-invoice-subscriptions-no-duration-type-parent-container">
                                                <div className="tenant-administrator-new-invoice-subscriptions-no-duration-type-container">
                                                    <h2>No subscriptions available</h2>
                                                    <p>Select a duration type in the Primary details page to proceed.</p>
                                                </div>
                                            </div>
                                        ):loadingAvailableSubscriptions?
                                        (
                                            <div className="tenant-administrator-new-invoice-loading-available-subscriptions-parent-container">
                                                <div className="tenant-administrator-new-invoice-loading-available-subscriptions-container">
                                                    <div></div>
                                                    <p>Loading available subscriptions. Please wait...</p>
                                                </div>
                                            </div>
                                        ):
                                        (
                                            <div className="tenant-administrator-new-invoice-subscription-entries-container">
                                                {subscriptionsEntries && subscriptionsEntries.map((subscriptionsEntry) =>(
                                                    <div className="tenant-administrator-new-invoice-subscription-entry-container">
                                                        <div className="tenant-administrator-new-invoice-subscription-entry-sub-container">
                                                            {subscriptionsEntry?.value?
                                                                (<div className="tenant-administrator-new-invoice-subscription-entry-value-container">
                                                                    <p>{subscriptionsEntry?.value?.deviceName}</p>
                                                                    <div>
                                                                        <p>{subscriptionsEntry?.value?.planName}</p>
                                                                        <p
                                                                            className="remove-p"
                                                                            title="Remove selection"
                                                                            onClick={() =>{
                                                                                setSubscriptionsEntries(prev => prev.map(entry => entry?.id === subscriptionsEntry?.id? {...entry,value:null}:entry));
                                                                            }}>&#10006;</p>
                                                                    </div>
                                                                </div>
                                                                ):
                                                                (
                                                                    <input
                                                                        value={subscriptionsEntry?.filterString}
                                                                        onChange={(e) =>{
                                                                            setSubscriptionsEntries(prev => prev.map(entry => entry?.id === subscriptionsEntry?.id? {...entry,filterString:e.target.value}:entry));
                                                                        }}
                                                                        onFocus={() =>{
                                                                            setSubscriptionsEntries(prev => prev.map(entry => entry?.id === subscriptionsEntry?.id? {...entry,showBrowser:true}:entry));
                                                                        }}
                                                                        onBlur={() =>{
                                                                            setTimeout(() =>{
                                                                                setSubscriptionsEntries(prev => prev.map(entry => entry?.id === subscriptionsEntry?.id? {...entry,showBrowser:false}:entry));
                                                                            },150);
                                                                        }}
                                                                    />
                                                                )
                                                            }
                                                            <div className={`tenant-administrator-new-invoice-subscriptions-browser ${subscriptionsEntry?.showBrowser? 'active':''}`}>
                                                                {availableSubscriptions && [...availableSubscriptions]
                                                                    .filter(availableSubscription => !selectedAvailableSubscriptionsIds?.includes(availableSubscription?.subscriptionId))
                                                                    .filter(availableSubscription => (
                                                                        (availableSubscription?.deviceName?.toLowerCase().includes(subscriptionsEntry?.filterString?.toLowerCase()) ||
                                                                        (availableSubscription?.planName?.toLowerCase().includes(subscriptionsEntry?.filterString?.toLowerCase()))
                                                                    ))).map((availableSubscription) =>(
                                                                    <div key={availableSubscription?.subscriptionId}
                                                                        onClick={() =>{
                                                                            setSubscriptionsEntries(prev => prev.map((entry) => entry?.id === subscriptionsEntry?.id? {...entry,value:availableSubscription}:entry));
                                                                        }}>
                                                                        <p>{availableSubscription?.deviceName}</p>
                                                                        <p>{availableSubscription?.planName}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        <img
                                                            title="Delete entry"
                                                            onClick={() => setSubscriptionsEntries(prev => prev.filter(entry => entry?.id !== subscriptionsEntry?.id))}
                                                            src={`${process.env.PUBLIC_URL}/images/trash-can-icon.png`}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            <div className="tenant-administrator-new-invoice-control-buttons-container">
                                <button className="cancel" onClick={() => disposeWindow()}>Cancel</button>
                                <button
                                    title={formValidToolTip()}
                                    className={`add ${formValidToolTip() === ''? 'active':'inactive'}`}
                                    onClick={async() => {
                                        if(formValidToolTip() === '') await createInvoice();
                                    }}>Add
                                </button>
                            </div>
                        </div>
                    </div>
                ):creatingInvoiceStatus === 'creating'?
                (
                    <div className="tenant-administrator-creating-invoice-container">
                        <div></div>
                        <p>Creating invoice. Please wait...</p>
                    </div>
                ):creatingInvoiceStatus === 'created'?
                (
                    <div className="tenant-administrator-invoice-created-container">
                        <h1>Invoice created</h1>
                        <p>Your invoice has been created successfully</p>
                        <div className="tenant-administrator-invoice-created-okay-button-container">
                            <button onClick={() => disposeWindow()}>Okay</button>
                        </div>
                        <div className="tenant-administrator-invoice-created-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <div className="tenant-administrator-create-invoice-failed-container">
                        <h1>Error</h1>
                        <p>Failed to create invoice. Please try again.</p>
                        <div className="tenant-administrator-create-invoice-failed-okay-button-container">
                            <button onClick={() => setCreatingInvoiceStatus('')}>
                                Okay
                            </button>
                        </div>
                        <div className="tenant-administrator-create-invoice-failed-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default NewInvoice;